export default __webpack_public_path__ + "images/onboarding/mentor-36378276ff059242e447f906017f812a.png";